import { motion } from 'framer-motion';

export const FadeIn = ({ children, delay = 0, ...props }: { children: React.ReactNode; delay?: number } & React.ComponentProps<typeof motion.div>) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-60px' }}
    transition={{ duration: 0.5, delay, ease: 'easeOut' }}
    {...props}
  >
    {children}
  </motion.div>
);
